module.exports = __webpack_public_path__ + "img/漏损平台.fbf997c6.png";